import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { CustomerJourneyService } from '../../service/customer-journey/customer-journey.service';
import { PreventBackToSettlementOrAuthGuard } from '../../guard/prevent-back-to-settlement-or-auth-guard.service';
import { routeNames } from '../../../assets/val/route-constants';
import { email_validation_regexp } from '../../../assets/val/regexp';
import { PaymentRequestDto } from 'src/app/model/payment-request/payment-request.dto';
import { LoggingService } from 'src/app/service/logging-service/logging.service';
import { UserService } from '@app/service/user-service/user.service';
import { TermsLinkService } from '@app/service/terms-link/terms-link.service';
import {
  formatPhoneNumber,
  nordicCountries,
  phoneNumberValidator,
} from 'web-component-library/projects/component-library/src/public-api';

@Component({
  selector: 'app-email-entry',
  templateUrl: './email-and-invoice.component.html',
  styleUrls: ['./email-and-invoice.component.css', '../page-shared.css'],
})
export class EmailAndInvoiceComponent implements OnInit {
  public loading = true;
  public navigationInProgress: boolean;
  public shouldDisplayEmailError = false;
  public emailErrorMessages = [
    'Ett oväntat fel har uppstått.',
    'Vänligen försök igen.',
  ];
  public paymentRequest: PaymentRequestDto;
  public stateSubscription;

  public form: FormGroup;
  public showError = false;

  constructor(
    private store: Store,
    private customerJourneyService: CustomerJourneyService,
    private router: Router,
    private preventBackToSettlementOrAuthGuard: PreventBackToSettlementOrAuthGuard,
    private loggingService: LoggingService,
    private userService: UserService,
    public termsLinkService: TermsLinkService
  ) {}

  async ngOnInit(): Promise<void> {
    const emailResp = await this.userService.fetchRegisteredEmail();
    const phoneResp = await this.userService.fetchRegisteredPhone();

    this.paymentRequest = this.store.snapshot().paymentRequest.request;

    this.form = new FormGroup({
      email: new FormControl(emailResp.email || '', [
        Validators.pattern(email_validation_regexp),
        Validators.required,
      ]),
      phone: new FormControl(phoneResp.phone || '', [
        Validators.required,
        phoneNumberValidator(nordicCountries, this.paymentRequest.market),
      ]),
    });

    this.loading = false;
  }

  async handleCtaClick() {
    if (this.navigationInProgress) {
      return;
    }

    if (this.form.valid) {
      try {
        await this.userService.registerEmail(this.form.value.email);
        await this.userService.registerPhone(
          formatPhoneNumber(this.form.value.phone, this.paymentRequest.market)
        );
        this.navigateOnEmailSubmitted();
      } catch (err) {
        this.loggingService.reportCrash(
          'front-end email validation disagrees with back-end, allowed ' +
            this.form.value.email +
            'which was rejected by back-end'
        );
        this.shouldDisplayEmailError = true;
      }
    } else {
      this.showError = true;
    }
  }

  private navigateOnEmailSubmitted() {
    // Reaching this point will mean some form of navigation.
    this.navigationInProgress = true;
    this.preventBackToSettlementOrAuthGuard.deactivate();

    this.customerJourneyService.getNextRoute().subscribe((route) => {
      this.router
        .navigate([route], {
          queryParamsHandling: 'preserve',
        })
        .then(
          () => {
            this.navigationInProgress = false;
            this.preventBackToSettlementOrAuthGuard.activate();
          },
          (rejection) => {
            this.loggingService.error(
              `Navigation from ${routeNames.EMAIL_AND_INVOICE} to ${route} was rejected.`,
              rejection
            );
          }
        );
    });
  }

  reroute(): void {
    this.router.navigate([routeNames.HOME], {
      queryParamsHandling: 'merge',
    });
  }
}
